export default class SizeGuide {
  constructor(context) {
    this.element = {
      context: context,
      toggle: context.querySelector('.toggle-metric__switch'),
      buttons: context.querySelectorAll('.toggle-metric__btn'),
      tables: [...context.querySelectorAll('.js-size-guide')],
      tableType: context.querySelector('.toggle-size-guide__btn')
        ? [...context.querySelectorAll('.toggle-size-guide__btn')]
        : false,
      croqui: context.querySelectorAll('.toggle-croqui__btn'),
    };

    this.unit = {
      rate: 2.54,
      metric: this.element.toggle?.dataset.metric,
      dimension: 'x',
      range: '-',
      tableRange: [],
    };
  }

  init() {
    // Determine if table data contain a range of values or dimensions
    this.setRangeValue();

    //set width based off of number of columns in the size guide. used for scrolling functionality on smaller screen sizes
    this.setWidth();

    // On click, convert table data
    this.element.buttons.forEach((element) => {
      element.addEventListener('click', (event) => {
        this.toggleMetric(event.target);
      });
    });

    // If >1 size guide table exists, add event to toggle table
    if (this.element.tableType) {
      this.element.tableType.forEach((element) => {
        element.addEventListener('click', (event) =>
          this.toggleTable(event.target)
        );
      });
    }

    this.element.croqui.forEach((element) => {
      element.addEventListener('click', (event) =>
        this.toggleCroqui(event.target)
      );
    });
  }

  setWidth = () => {
    const { tables } = this.element;
    tables?.forEach((table) => {
      const columns = table.querySelector('tr:first-of-type').childElementCount;
      const width = columns * 120;
      table.querySelector('table').style.width = `${width}px`;
    });
  };
  toggleCroqui = (button) => {
    const { context } = this.element;
    context.querySelector(
      '.toggle-croqui__btn[data-active="true"]'
    ).dataset.active = false;
    context.querySelector(
      '.js-measure[data-enable="true"]'
    ).dataset.enable = false;
    context.querySelector(
      `.size-guide__${button.dataset.type}`
    ).dataset.enable = true;
    button.dataset.active = true;
    context.querySelector('.size-guide__toggle').dataset.enable =
      button.dataset.type == 'table';
  };

  toggleTable = (button) => {
    const { tables, tableType } = this.element,
      currentTable = tables.find(
        (table) => table.dataset.type !== button.dataset.type
      ),
      newTable = tables.find(
        (table) => table.dataset.type == button.dataset.type
      ),
      currentActiveBtn = tableType.find((type) => type !== button);
    let dataset = newTable.dataset.enable.includes('false');
    if (dataset) {
      // toggle table display
      currentTable.dataset.enable = !dataset;
      newTable.dataset.enable = dataset;

      // toggle btn styles
      currentActiveBtn.dataset.active = !dataset;
      button.dataset.active = dataset;
    }
  };

  toggleMetric = (button) => {
    // if span tag is clicked, set button to parentElement
    button = button.tagName.includes('SPAN') ? button.parentElement : button;

    const { toggle } = this.element,
      buttonMetric = button.dataset.metric;

    // If user clicked toggle button or current & clicked metric are different, update measurements
    if (buttonMetric !== this.unit.metric || button == toggle) {
      let newMetric = buttonMetric.includes('in') ? 'cm' : 'in';
      this.unit.metric = button == toggle ? newMetric : buttonMetric;

      toggle.setAttribute('data-metric', this.unit.metric);
      this.updateMeasurement(this.unit.metric);
    }
  };

  updateMeasurement = (metric, initialLoad = false) => {
    this.element.tables.forEach((table, index) => {
      const tableData = [...table.querySelectorAll('td:not(.column-headers)')];
      const nonconvertible = tableData.every((data) => {
        const text = this.simplifyData(data.innerText),
          value = this.parseInt(text),
          numericType = data.dataset.measurement;
        return !value || numericType;
      });

      if (nonconvertible)
        this.element.context.querySelector(
          '.size-guide__toggle'
        ).dataset.enable = false;
      else {
        tableData.forEach((data) => {
          const text = this.simplifyData(data.innerText),
            value = this.parseInt(text),
            notNumericType = !data.dataset.measurement;
          // If table data is a Number, convert value
          if (value && notNumericType) {
            let newMeasurement = value,
              htmlMetric = metric.includes('in') ? '&quot;' : ` ${metric}`;

            // If converting to in, use data-value to replace innerHtml
            if (initialLoad) data.setAttribute('data-value', value);
            // If converting to cm, run values through conversion function
            else
              newMeasurement = metric.includes('in')
                ? data.dataset.value.split(',')
                : typeof value == 'object'
                ? value.map((num) => this.convertToCm(num))
                : this.convertToCm(value);

            let newUnit =
              typeof newMeasurement == 'object'
                ? newMeasurement.map((num) => num + htmlMetric)
                : newMeasurement + htmlMetric;

            // update table data with converted value and new metric
            data.innerHTML =
              typeof newUnit == 'object'
                ? newUnit.join(` ${this.unit.tableRange[index]} `)
                : newUnit;
          }
        });
      }
    });
  };

  convertToCm = (value) => {
    // Convert in to cm by multiplying 2.54
    const { metric, rate } = this.unit;
    let newMetric = metric.includes('in') ? value / rate : value * rate;
    return this.roundNearestHalf(newMetric);
  };

  setRangeValue() {
    // storing table range values to add back in after conversion
    const { dimension, range, tableRange } = this.unit;
    this.element.tables.forEach((table, index) => {
      const tableData = [...table.querySelectorAll('td')],
        matchRange = tableData.some((data) => data.innerText.includes(range));
      tableRange[index] = matchRange ? range : dimension;
    });

    // On load, update table data with appropriate metric
    this.updateMeasurement(this.unit.metric, true);
  }

  // Update table data cell into integers
  // Values containing a range of numbers are converted to an array
  parseInt = (text) =>
    text.includes(',') ? text.split(',').map(Number) : parseFloat(text);

  // Round to the nearest .5 decimal
  roundNearestHalf = (num) => Math.floor(Math.ceil(num * 2) / 2);

  // Update x or - into comma to be split into array
  simplifyData = (text) => {
    const rangeValues = new RegExp(`[${this.unit.tableRange.join('')}]`, 'g');
    return text.replaceAll(rangeValues, ',').replace(/[^0-9,.]/g, '');
  };
}
